var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tag',{class:[_vm.baseClass],attrs:{"value":_vm.value,"icon":_vm.icon,"severity":_vm.severity,"rounded":_vm.rounded}})
}
var staticRenderFns = []

export { render, staticRenderFns }